var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreasuryCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43523 4.93517C5.79321 4.57719 6.37362 4.57719 6.7316 4.93517L8.83341 7.03699L10.9352 4.93517C11.2932 4.57719 11.8736 4.57719 12.2316 4.93517C12.5896 5.29315 12.5896 5.87355 12.2316 6.23153L10.1298 8.33335L12.2316 10.4352C12.5896 10.7932 12.5896 11.3736 12.2316 11.7315C11.8736 12.0895 11.2932 12.0895 10.9352 11.7315L8.83341 9.62972L6.7316 11.7315C6.37362 12.0895 5.79321 12.0895 5.43523 11.7315C5.07725 11.3736 5.07725 10.7932 5.43523 10.4352L7.53705 8.33335L5.43523 6.23153C5.07725 5.87355 5.07725 5.29315 5.43523 4.93517Z",
    fill: "#C4D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasuryCross);
export default __webpack_public_path__ + "static/media/treasury-cross.fdc84876.svg";
export { ForwardRef as ReactComponent };